import { render, staticRenderFns } from "./FormBoundary.vue?vue&type=template&id=28b30b46&"
import script from "./FormBoundary.vue?vue&type=script&lang=js&"
export * from "./FormBoundary.vue?vue&type=script&lang=js&"
import style0 from "./FormBoundary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports